module.exports = __webpack_public_path__ + "static/media/top_shape_3a.84d6f08f.svg";